export function LanguageSwitcher(): JSX.Element | null {
  return null;
}
